module.exports = __webpack_public_path__ + "static/crosslink-landing-e3523e19d9080417676668b35f718930.jpg";